<template>
    <div>
        <el-tabs v-model="query.search_status" @tab-click="handleSearch">
            <el-tab-pane label="上架" name="1"></el-tab-pane>
            <el-tab-pane label="下架" name="2"></el-tab-pane>
        </el-tabs>
        <ListPage ref="listPage" :query="query" :total="total" v-loading="loading" :data="tableData"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" @search="handleSearch"
            @reset="resetQuery" @selection-change="handleSelectionChange">
            <template slot="filters">
                <el-form-item label="" prop="search_keyword">
                    <el-input v-model="query.search_keyword" placeholder="输入商品标题进行检索" clearable
                        @keyup.enter.native="handleSearch" />
                </el-form-item>
                <el-form-item label="系列" prop="category_type">
                    <el-select v-model="query.category_type">
                        <el-option label="连接器" value="1"></el-option>
                        <el-option label="工具" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="分类" prop="search_category_uuid">
                    <CategorySelector :disabled="!query.category_type" :type="query.category_type"
                        v-model="query.search_category_uuid"></CategorySelector>
                </el-form-item>
                <el-form-item label="状态" prop="search_is_ok">
                    <el-select v-model="query.search_is_ok" placeholder="请选择状态">
                        <el-option label="正常" value="1" />
                        <el-option label="停售" value="2" />
                    </el-select>
                </el-form-item>
            </template>
            <template slot="btns"
                v-if="permission('cpgl_cplb_pldr') || permission('cpgl_cplb_cpsy') || permission('cpgl_cplb_pldc') || permission('cpgl_cplb_xz')">
                <el-button v-if="permission('cpgl_cplb_mbxz')" size="mini" type="primary" @click="handleDownload"> 模板下载
                </el-button>
                <el-upload style="margin: 0 10px" v-if="permission('cpgl_cplb_pldr')" action="" :show-file-list="false"
                    :before-upload="beforeUpload">
                    <el-button size="small" type="primary">批量导入</el-button>
                </el-upload>
                <el-button v-if="query.search_status == 1 && permission('cpgl_cplb_cpsy')" size="mini" type="primary"
                    @click="handleWatermark">
                    产品水印
                </el-button>
                <el-button v-if="permission('cpgl_cplb_pldc')" size="mini" type="primary" @click="handleExport"> 批量导出
                </el-button>
                <el-button v-if="permission('cpgl_cplb_xz')" size="mini" type="primary" @click="handleAdd"> 新增
                </el-button>
            </template>
            <template slot="columns">
                <el-table-column type="selection" width="50" align="center"></el-table-column>
                <el-table-column label="封面图" align="center">
                    <template slot-scope="{ row }">
                        <img style="height: 40px" @click="handlePreview(row.cover_img)" :src="ossUrl + row.cover_img"
                            alt="" />
                    </template>
                </el-table-column>
                <el-table-column label="商品标题" align="center" prop="name" />
                <el-table-column label="分类" align="center" prop="category_display" />
                <el-table-column label="官方指导价" align="center" prop="guide_price" />
                <el-table-column label="状态" align="center">
                    <template slot-scope="{ row }">
                        {{ row.is_ok == 1 ? "正常" : "停售" }}
                    </template>
                </el-table-column>
                <el-table-column v-if="
                    permission('cpgl_cplb_ts') ||
                    permission('cpgl_cplb_bj') ||
                    permission('cpgl_cplb_xj') ||
                    permission('cpgl_cplb_sj') ||
                    permission('cpgl_cplb_sc')
                " label="操作" align="center" width="200">
                    <template slot-scope="{ row }">
                        <el-button v-if="query.search_status == 1 && permission('cpgl_cplb_ts')" size="mini" type="text"
                            @click="handleSellout(row)">
                            {{ row.is_ok == 1 ? "停售" : "正常" }}
                        </el-button>
                        <el-button v-if="permission('cpgl_cplb_bj')" size="mini" type="text" @click="handleEdit(row, query)">
                            编辑 </el-button>
                        <el-button v-if="permission(row.statue == 1 ? 'cpgl_cplb_xj' : 'cpgl_cplb_sj')" size="mini"
                            type="text" @click="handleStatus(row)">
                            {{ row.status == 1 ? "下架" : "上架" }}
                        </el-button>
                        <el-button v-if="permission('cpgl_cplb_sc')" size="mini" type="text" @click="handleDel(row)"> 删除
                        </el-button>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
        <PicPreviewer ref="preview"></PicPreviewer>
    </div>
</template>

<script>
import CategorySelector from "@/components/CategorySelector";
import { ossUrl } from "@/configs/oss";
import { list, del, edit, download, _import } from "@/api/product/list";
import listMixin from "@/mixins/list";
import { downloadFileByUrl } from "@/jslibs/utils";
import PicPreviewer from "@/components/PicPreviewer";
import utils from "@/jslibs/utils";

export default {
    components: { CategorySelector, PicPreviewer },
    data() {
        return {
            list,
            del,
            ossUrl,
            // 查询参数
            query: {
                search_status: "1",
                search_keyword: "",
                category_type: "",
                search_category_uuid: "",
                search_is_ok: "",
            },
            formPath: "/product/list/form",
            uuidKey: "cuuid",
            module: "商品",
            pick: true,
        };
    },
    mixins: [listMixin],
    mounted() {
		this.query = this.$route.query ? { ...this.query, ...this.$route.query } : this.query;
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleDownload() {
            download().then((res) => {
                const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const filename = "产品模板.xlsx";
                utils.downloadBlobFile(blob, filename);
            });
        },
        beforeUpload(file) {
            _import({ file }).then(({ code, error }) => {
                if (code === 200) {
                    this.$message.success("导入成功");
                    this.handleSearch();
                } else {
                    this.$message.error(error.message);
                }
            });
            return false;
        },
        handlePreview(url) {
            this.$refs.preview.open(url);
        },
        handleWatermark() {
            this.$router.push({ path: "/product/watermark" });
        },
        handleSelectionChange(val) {
            this.ids = val.map((x) => x.uuid);
            this.names = val;
            this.ids_d = this.tableData.filter((x) => this.ids.indexOf(x.uuid) === -1).map((x) => x.uuid);
            this.merge();
        },
        async handleExport() {
            const filename = "产品列表.xlsx";
            const { search_keyword, search_category_uuid, search_status, search_is_ok } = this.query;
            const uuids = this.picks.map(x => x.uuid).join();
            downloadFileByUrl(
                process.env.VUE_APP_BASE_URL +
                `/v1/cms/Goods?export=1&search_keyword=${search_keyword}&search_status=${search_status}&search_is_ok=${search_is_ok}&search_category_uuid=${search_category_uuid}&uuids=${uuids}`,
                filename
            );
        },
        handleSellout(row) {
            edit({ uuid: row.uuid, is_ok: row.is_ok == 1 ? 2 : 1, flag: 2 }).then(({ code, error }) => {
                if (code == 200) {
                    this.search();
                    this.$message.success(row.is_ok == 1 ? "停售成功" : "恢复正常成功");
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleStatus(row) {
            edit({ uuid: row.uuid, status: row.status == 1 ? 2 : 1, flag: 1 }).then(({ code, error }) => {
                if (code == 200) {
                    this.search();
                    this.$message.success(row.status == 1 ? "下架成功" : "上架成功");
                } else {
                    this.$message.error(error.message);
                }
            });
        },
    },
};
</script>
